import { render, staticRenderFns } from "./TestComponent2.vue?vue&type=template&id=9c05bca2&"
import script from "./TestComponent2.vue?vue&type=script&lang=ts&"
export * from "./TestComponent2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports